export const MIN_VOTES_TO_SHOW_AVATAR = 200
